import { PopoverButton } from "@headlessui/react";
import { twMerge } from "tailwind-merge";

const TOOLTIP_ALIGN = {
  left: "left-0",
  center: "left-1/2 -translate-x-1/2",
  right: "right-0",
} as const;

const TOOLTIP_PLACEMENT = {
  top: "bottom-[calc(100%+6px)]",
  bottom: "top-[calc(100%+6px)]",
} as const;

const ACTION_BUTTON_CLASS =
  "hover:bg-grey2 flex h-[34px] w-[34px] cursor-pointer items-center justify-center rounded-[6px]";

export const ActionButton: React.FC<{
  icon: React.ReactNode;
  label: string;
  align?: keyof typeof TOOLTIP_ALIGN;
  placement?: keyof typeof TOOLTIP_PLACEMENT;
  alwaysVisible?: boolean;
  popover?: boolean;
  tooltipHidden?: boolean;
  buttonRef?: React.Ref<HTMLButtonElement>;
  onClick?: () => void;
}> = ({
  icon,
  label,
  align = "center",
  placement = "top",
  alwaysVisible,
  popover,
  tooltipHidden,
  buttonRef,
  onClick,
}) => (
  <span
    className={twMerge(
      "group/tip relative inline-flex transition-opacity",
      alwaysVisible
        ? "opacity-100"
        : "opacity-0 group-focus-within/row:opacity-100 group-hover/row:opacity-100",
    )}
  >
    {popover ? (
      <PopoverButton
        ref={buttonRef}
        type="button"
        aria-label={label}
        onClick={onClick}
        className={ACTION_BUTTON_CLASS}
      >
        {icon as never}
      </PopoverButton>
    ) : (
      <button
        ref={buttonRef}
        type="button"
        aria-label={label}
        onClick={onClick}
        className={ACTION_BUTTON_CLASS}
      >
        {icon}
      </button>
    )}
    <span
      className={twMerge(
        "pointer-events-none absolute z-[70] rounded-[4px] bg-black px-[7px] py-[5px] text-[11px] font-medium whitespace-nowrap text-white opacity-0 transition-opacity",
        !tooltipHidden &&
          "group-focus-within/tip:opacity-100 group-hover/tip:opacity-100",
        TOOLTIP_PLACEMENT[placement],
        TOOLTIP_ALIGN[align],
      )}
    >
      {label}
    </span>
  </span>
);
